import React from 'react';
import LandingPage from '../components/LandingPage.jsx';
import Footer from '../components/Footer.jsx';
function Home() {
  return (
    <>
      <LandingPage />
      <Footer />
    </>
  );
}

export default Home;
